/**
 * /try format icons — re-exports the protocol glyph set and maps create-module tabs.
 *
 * @file src/client/try-format-icons.ts
 */

import {
  createSourceFormatIconElement,
  renderSourceFormatIconSvg,
  SourceFormatIconMarkup,
  SourceFormatIconViewBox
} from '@gist-protocol/core/shared/source-format-icons.js';
import type { TryMode } from './try-mode-tabs.js';

export type TryFormatIconKind = 'url' | 'text' | 'file' | 'youtube' | 'googledoc' | 'media';

export const TryFormatIconViewBox = SourceFormatIconViewBox;
export const TryFormatIconMarkup = SourceFormatIconMarkup;

/** Mirrors {@link TryModes} without importing it (avoids cycle with try-mode-tabs). */
const MODE_TO_ICON: Readonly<Record<TryMode, TryFormatIconKind>> = Object.freeze({
  text: 'text',
  url: 'url',
  file: 'file',
  youtube: 'youtube',
  googledoc: 'googledoc'
});

export function resolveTryFormatIconKind(mode: TryMode): TryFormatIconKind {
  return MODE_TO_ICON[mode];
}

export function renderTryFormatIconSvg(
  kind: TryFormatIconKind,
  options: { className?: string; ariaHidden?: boolean } = {}
): string {
  return renderSourceFormatIconSvg(kind, options);
}

export function createTryFormatIconElement(
  kind: TryFormatIconKind,
  className?: string
): SVGSVGElement {
  return createSourceFormatIconElement(kind, className);
}
